import { render, staticRenderFns } from "./comp_VariantsSelector.vue?vue&type=template&id=d4bf9398&scoped=true"
import script from "./comp_VariantsSelector.vue?vue&type=script&lang=js"
export * from "./comp_VariantsSelector.vue?vue&type=script&lang=js"
import style0 from "./comp_VariantsSelector.vue?vue&type=style&index=0&id=d4bf9398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bf9398",
  null
  
)

export default component.exports